export default "__VITE_ASSET__aILWVOZL__"